import React, { useState, useEffect, useRef } from 'react';


const ActivityItem = (props) => {
    const [ selected, setSelected ] = useState(false);

    const style = {
        backgroundColor: selected ? '#46474a' : '#282a2f',
        padding: 10,
        borderRadius: "50%",
        borderBottom: selected ? '1px solid #383a40' : '1px solid #383a40',
        cursor: 'pointer',
        textAlign: "center",
        fontSize: 10,
        margin: 7
    
    }

    function makeSelected() {
        if (!selected) {
            setSelected(true);
        }

        props.getSelectedId(props.dataKeyId, (key) => {
            if (props.dataKeyId == props.selectedId && !selected) {
                setSelected(true);
            }
        });

        props.callChatAPI(props.statement + " Find any past conversations I have said or talked about that helps me with this. **FORMAT THIS for a text message. Make sure it looks good to send as a text.");
    }

    if (props.dataKeyId != props.selectedId && selected) {
        setSelected(false);
    }
  
    return (
        <div className="" style={style} onClick={makeSelected}>
            {props.children}
        </div>
    );
};


export default ActivityItem;